import { ITag } from '../tagging/Tag';

export class SearchTermList {
  public id: string;
  public projectId: string;
  public name: string;
  public terms: string[];
  public tag: ITag;
  public tagWithRelated: ITag;
  public duplicateTag: ITag;

  constructor(id: string, projectId: string, name: string, terms: string[], tag?: ITag, tagWithRelated?: ITag, duplicateTag?: ITag) {
    this.id = id;
    this.projectId = projectId;
    this.name = name;
    this.terms = terms;
    this.tag = tag || null;
    this.tagWithRelated = tagWithRelated || null;
    this.duplicateTag = duplicateTag || null;
  }
}

